import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';

function stripQuotes(value: string): string {
  return value.replace(/^['"]|['"]$/g, '').trim();
}

function env(key: string): string {
  const raw = import.meta.env[key as keyof ImportMetaEnv];
  if (typeof raw !== 'string') return '';
  return stripQuotes(raw);
}

export const firebaseWebConfig = {
  apiKey: env('VITE_APP_FIREBASE_API_KEY'),
  authDomain: env('VITE_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: env('VITE_APP_FIREBASE_PROJECT_ID'),
  storageBucket: env('VITE_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: env('VITE_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: env('VITE_APP_FIREBASE_APP_ID'),
  measurementId: env('VITE_APP_FIREBASE_MEASUREMENT_ID')
};

export function isFirebaseWebConfigured(): boolean {
  return Boolean(firebaseWebConfig.apiKey && firebaseWebConfig.messagingSenderId && firebaseWebConfig.appId);
}

export function getFirebaseWebVapidKey(): string {
  return env('VITE_APP_FIREBASE_VAPID_KEY');
}

export function getFirebaseWebApp(): FirebaseApp {
  const apps = getApps();
  if (apps.length > 0) {
    return apps[0];
  }
  return initializeApp(firebaseWebConfig);
}
